import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { financesSelectors } from '../../../store/selectors/finances';
import actions from '../../../store/actions';

import Button from '../../../common/Buttons/Button';

import './pay-btns.style.scss';

const FinancesPayBtns = ({ method, setOpenModal, loadingBtn, setLoadingBtn }) => {
  const dispatch = useDispatch();

  const finances = useSelector(financesSelectors);
  const invoice = finances.invoice;
  const link = finances.link;

  useEffect(() => {
    if (link) {
      window.location.href = link;
      setLoadingBtn(false);
      dispatch(actions.finances.getPaymentLink(''));
    }
  }, [link]);

  const setModalData = (method, appointment, name, url) => {
    setOpenModal({ 'open': true, method, appointment, name, url });
    document.body.classList.add('open');
  };

  return (
    <div className="pay-btns-block">
      <Button
        buttonBg='green'
        icon={method.image}
        iconAlt={method.button_name}
        disabled={loadingBtn ? true : false}
        onClick={() => setModalData(method, invoice.appointment, invoice.document_number, invoice.document_url)}
      >
        <span>{method.button_name}</span>
      </Button>

      <span className='pay-btns-block__text'>{method.button_description}</span>

      {method.commission_note && (
        <span className='pay-btns-block__note'>
          <svg className='pay-btns-block__note-icon' viewBox='0 0 20 20' aria-hidden='true'>
            <path d='M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm.833 12.5H9.167V9.167h1.666v5Zm0-6.667H9.167V5.833h1.666V7.5Z' />
          </svg>
          <span className='pay-btns-block__note-text'>{method.commission_note}</span>
        </span>
      )}
    </div>
  );
};

FinancesPayBtns.propTypes = {
  method: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  loadingBtn: PropTypes.bool.isRequired,
  setLoadingBtn: PropTypes.func.isRequired,
};

export default FinancesPayBtns;
